export default {
  state: {
    id: undefined,
    name: undefined,
    summary: undefined,
    description: undefined,
    date: undefined,
    created_at: undefined,
    updated_at: undefined,
    sort_by: undefined,
    difficulty: undefined,
    user_difficulty: undefined,
    price: undefined,
    rating: undefined,
    image_url_sd: undefined,
    image_url_medium: undefined,
    image_url_hd: undefined,
    import_puzzles: undefined,
    content_url: undefined,
    sample_puzzle_id: undefined,
    language_id: undefined,
    format: undefined,
    is_light: undefined,
    is_full: undefined,
    inactive: undefined,
    public: undefined,
    puzzle_count: undefined,
    icon_url: undefined,
    custom_name: undefined,
    purchasable_item_id: undefined,
    start_at: undefined,
    end_at: undefined,
    purchasable_item: {},
    puzzles: [],
    relationships: {}
  }
}



// WEBPACK FOOTER //
// ./src/stores/BundleStore.js